import { render, staticRenderFns } from "./com-page-number.vue?vue&type=template&id=26d1dedc&"
import script from "./com-page-number.vue?vue&type=script&lang=js&"
export * from "./com-page-number.vue?vue&type=script&lang=js&"
import style0 from "./com-page-number.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports